<div class="block w-full relative"
  [ngStyle]="{ padding: linePadding }">
  <div>
    <vsf-title-box
        [titleInfo]="titleInfo"
        [forComponent]="true">
    </vsf-title-box>
  </div>
  <!-- FAQ Items -->
  <div *ngFor="let faq of getVisibleFaqs()" class="max-w-3xl mx-auto border-t border-gray-300 py-3">
    <div (click)="toggleFaq(faq)" class="flex justify-between cursor-pointer">
      <span class="text-base text-gray-800" [innerHTML]="faq.question | safeHtml"></span>
      <span class="text-xl text-gray-500">{{ faq.open ? '-' : '+' }}</span>
    </div>
    <div *ngIf="faq.open" class="mt-2 pl-4 border-l-2 border-gray-400">
      <span class="text-base rich-text-content" [innerHTML]="faq.answer | safeHtml"></span>
    </div>
  </div>

  <!-- "View All Questions" Button -->
  <div *ngIf="!showAll && qaList.length > defaultDisplayCount" class="flex justify-center mt-4">
    <button (click)="showAllQuestions()"
            class="btn btn-primary">
      View All Questions
    </button>
  </div>
</div>
